import debounce from './util/debounce.js';
import register from '../register.js';

class Accordion {
  constructor( el ) {
    this.el = el;
    this.trigger = this.el.querySelector('[data-accordion-trigger]');
    this.content = this.el.querySelector('[data-accordion-content]');
    this.expandMore = this.el.querySelector('.expand-more') || null;
    // eslint-disable-next-line max-len
    this.closeToggles = this.el.querySelectorAll('[data-accordion-close-toggle]');
    this.setOpen( false );
    this.height = 0;
    this.activeClass = 'is-open';
    this.hiddenClass = 'is-hidden';

    this.bindEvents();
    this.close();
  }

  bindEvents() {
    this.trigger.addEventListener( 'click', this.handleClick.bind( this ) );
    this.closeToggles.forEach( t => {
      t.addEventListener( 'click', this.handleClick.bind( this ) );
    });
    // this.content.addEventListener(
    //   'transitionend', this.handleTransition.bind( this )
    // );
  }

  handleClick() {
    this.height = this.content.scrollHeight;

    if ( this.isOpen ) {
      this.close();
    } else {
      this.open();
    }
  }

  setOpen( val ) {
    val = !!val;
    this.isOpen = val;
    this.content.dataset.open = val ? 'true' : false;
  }

  close() {
    this.setOpen( false );
    this.el.classList.remove( this.activeClass );
    this.trigger.classList.remove( this.activeClass );
    this.content.style.maxHeight = 0 + 'px';
    if ( this.expandMore ) {
      this.expandMore.innerText = 'More';
    }
  }

  open() {
    this.setOpen( true );
    this.el.classList.add( this.activeClass );
    this.trigger.classList.add( this.activeClass );
    this.el.classList.remove( this.hiddenClass );
    this.content.style.maxHeight = this.height + 'px';
    if ( this.expandMore ) {
      this.expandMore.innerText = 'Less';
    }
  }

  handleTransition() {
    if ( !this.isOpen ) {
      this.el.classList.add( this.hiddenClass );
    }
  }
}

function init() {
  let contentElems;
  let adjustMaxHeights;

  contentElems = document.querySelectorAll('[data-accordion-content]');

  document.querySelectorAll('[data-accordion]').forEach( el => {
    new Accordion( el );
  });

  adjustMaxHeights = debounce( () => {
    contentElems.forEach( elem => {
      if ( elem.dataset.open === 'true' ) {
        elem.style.maxHeight = elem.scrollHeight + 'px';
      }
    });
  }, 300 );

  window.addEventListener( 'resize', adjustMaxHeights );
}

register( 'accordions', init );

export default undefined;
